import DefaultRoutes from './DefaultRoutes'
import MotoristasRoutes from './MotoristasRoutes'
import RevendasRoutes from './RevendasRoutes'
import PedidosRoutes from './PedidosRoutes'
import RelatoriosRoutes from './RelatoriosRoutes'
import FinancasRoutes from "./FinancasRoutes";

export default [
  ...DefaultRoutes,
  ...MotoristasRoutes,
  ...RevendasRoutes,
  ...PedidosRoutes,
  ...RelatoriosRoutes,
  ...FinancasRoutes
]
